export default __webpack_public_path__ + "static/media/login-bg-12.59596666.jpg";